<template lang="pug">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5858 10.9999L13.2218 5.63589L14.636 4.22168L21.7071 11.2927C22.0976 11.6833 22.0976 12.3164 21.7071 12.707L14.636 19.778L13.2218 18.3638L18.5858 12.9999H2V10.9999H18.5858Z" fill="#141414"/>
    </svg>
</template>

<style lang="stylus" scoped>

</style>

<script>
export default {
    methods:{
        emitClick(event){
            this.$emit('click', event)
        }
    }
}
</script>
